// src/components/HeadMeta.jsx
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";

const HeadMeta = () => {
  const [meta, setMeta] = useState(null);
  const { lang } = useLanguage();

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_SITE_SETTINGS_ENDPOINT}`
        );
        setMeta(response.data);
      } catch (err) {
        console.error("خطا در دریافت تنظیمات سایت", err);
      }
    };
    fetchMeta();
  }, []);

  if (!meta) return null;

  const title = meta[`site_title_${lang}`] || meta.site_title_fa || "سایت";
  const description =
    meta[`site_description_${lang}`] || meta.site_description_fa || "";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="icon" href={meta.favicon_url} />

      {/* شبکه‌های اجتماعی */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {meta.logo_url && <meta property="og:image" content={meta.logo_url} />}
    </Helmet>
  );
};

export default HeadMeta;
